<template>
    <modal-form
        editTitle="Flugverbindung bearbeiten"
        createTitle="Neue Flugverbindung hinzufügen"
        v-bind:isLoading="isLoading"
    >
        <table>
            <tr>
                <th><label for="startAirport" class="label">Flughafen Abflug:</label></th>
                <td>
                    <div class="control">
                        <async-select
                            api     = "airports"
                            v-model = "form.startAirport"
                            crudLinkTitle = "Fügen Sie einen neuen Flughafen hinzu"
                        />
                    </div>
                </td>
            </tr>
            <tr>
                <th><label for="endAirport" class="label">Flughafen Ankunft:</label></th>
                <td>
                    <div class="control">
                         <async-select
                            api     = "airports"
                            v-model = "form.endAirport"
                            crudLinkTitle = "Fügen Sie einen neuen Flughafen hinzu"
                        />
                    </div>
                </td>
            </tr>
            <tr v-if="!form.id">
                <th><label class="label">Option:</label></th>
                <td>
                    <div class="control">
                        <label class="checkbox">
                            <input type="checkbox" v-bind:value="true" v-model="form.return">Rückflug automatisch hinzufügen
                        </label>
                    </div>
                </td>
            </tr>
        </table>
    </modal-form>
</template>



<script>
import TabForm from '../form';


export default {
    mixins: [ TabForm ],


    form: {
        startAirport: null,
        endAirport: null,
        return: ''
    },


    property: 'airlineRoutes',


    methods: {
        handleSubmit: function () {
            this.isLoading = true;
            const { return: addReturn, ...data } = this.form;

            Promise.all([
                this.$store.dispatch('updateProperty', { key: 'airlineRoutes', data }),
                ...!this.editMode && addReturn ? [ this.$store.dispatch('updateProperty', {
                    key: 'airlineRoutes',
                    data: { ...data, startAirport: data.endAirport, endAirport: data.startAirport }
                }) ] : []
            ]).then(() => {
                this.visible = false;
                this.notifySuccess('Das Element wurde erfolgreich hinzugefügt!');
            }, () => {
                this.notifyError('Das Element konnte nicht hinzugefügt werden! Server Error!');
            }).then(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>
